// Which waves exist, in one place.
//
// This list was previously repeated in six components, each with its own
// default selection, so publishing a wave meant finding all six — and missing
// one showed stale data on that page only, which looks like a data problem
// rather than a frontend one.
//
// Adding a wave: append to WAVES. Nothing else needs touching, and the
// default selection follows automatically.
//
// The backend does not constrain this — core/loaders.py globs `wave=*` and
// serves whatever is in the Parquet mirror — so a wave added here before it
// is published will return empty, and a wave published but not added here is
// simply never requested.

export const WAVES = [1, 2, 3, 4];

/** Wave shown on first load — always the most recent. */
export const LATEST_WAVE = WAVES[WAVES.length - 1];

/** Previous wave, for the change/comparison views. null when only one exists. */
export const PREVIOUS_WAVE = WAVES.length > 1 ? WAVES[WAVES.length - 2] : null;

/** `[{value, label}]`, for the MUI selects that want option objects. */
export const WAVE_OPTIONS = WAVES.map((w) => ({ value: w, label: w }));
